import React from 'react';
import MyMatchesPage from 'app/routes/matchCalendar/myMatches/MyMatchesPage';
import MyMatchesUnauthorizedPage from 'app/routes/matchCalendar/myMatches/MyMatchesUnauthorizedPage';
import {validateAuthStateLocalToken} from 'app/hooks/useAuthState';
import {useSelector} from 'react-redux';
import {selectAuthState, selectFetchStates} from 'app/hooks/reduxCreateSelectorHooks';

const MyMatchesWrapperPage = props => {
  const {hasValidLocalToken} = validateAuthStateLocalToken();
  const {followsFetched} = useSelector(selectFetchStates);
  const isAuthenticated = useSelector(selectAuthState);
  const hasValidToken = isAuthenticated || hasValidLocalToken;
  if (hasValidToken) {
    return <MyMatchesPage />;
  } else {
    return <MyMatchesUnauthorizedPage loading={props.initializing || (isAuthenticated && !followsFetched)} />;
  }
};

export default MyMatchesWrapperPage;
